<template>
  <div>
    <form action @submit.prevent="resetPassword">
      <div class="mb-4">
        <label class="block text-grey-darker text-sm font-bold mb-2" for="email">{{ $t('Email') }}</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
          id="email"
          type="email"
          placeholder
          v-model="email"
        />
      </div>
      <div class="mb-4">
        <label
          class="block text-grey-darker text-sm font-bold mb-2"
          for="password"
        >Neues Passwort</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
          id="password"
          type="password"
          placeholder
          v-model="password"
        />
      </div>
      <div class="mb-6">
        <label
          class="block text-grey-darker text-sm font-bold mb-2"
          for="password"
        >{{ $t('ConfirmPassword')}}</label>
        <input
          class="shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3"
          id="password1"
          type="password"
          placeholder
          v-model="password_confirmation"
        />
      </div>
      <button
        class="bg-teal-400 hover:bg-blue-dark text-white font-bold py-2 px-4 rounded hover:bg-white hover:text-teal-400"
        type="submit"
      >Passwort zurücksetzen</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      password: "",
      password_confirmation: "",
      email: "",
      token: this.$route.params.token
    };
  },
  methods: {
    resetPassword() {
      axios
        .post(`${process.env.VUE_APP_API}/password/reset`, {
          email: this.email,
          token: this.token,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(() => this.$router.push({path: '/login'}))
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>